module.exports = __webpack_public_path__ + "img/icon-hs-article.138043a7.svg";